<i18n src="@/i18n/template/components/TableButtons.json"></i18n>
<script>
export default {
  props: {
    defaultBtnNumber: {
      type: Number,
      default: 3
    }
  },
  render(h) {
    const buttons = (this.$slots.default || []).filter(item => {
      if (item.data?.directives?.length > 0) {
        for (let directive of item.data.directives) {
          if (directive.name === 'permission') {
            return this.globalButtonPermission(directive.value || directive.arg)
          }
        }
      }
      return item.componentOptions
    })
    const showMore = buttons.length >= this.defaultBtnNumber
    let children = buttons
    if (showMore) {
      const [firstBtn, ...restBtn] = buttons
      children = [
        firstBtn,
        h(
          'el-dropdown',
          {
            on: {
              command(index) {
                let item = restBtn[index]
                if (!item) return
                item.componentOptions.listeners.click(item.componentInstance)
              }
            }
          },
          [
            h(
              'span',
              {
                style: {
                  color: '#4d03d4',
                  fontSize: '12px'
                }
              },
              [
                this.$t('More'),
                h('i', { class: 'el-icon-arrow-down el-icon--right' })
              ]
            ),
            h(
              'el-dropdown-menu',
              {
                slot: 'dropdown'
              },
              restBtn.map((item, index) => {
                return h(
                  'el-dropdown-item',
                  {
                    props: {
                      command: index
                    }
                  },
                  [
                    h(
                      // remove onClick listener, run into el-dropdown's command
                      item.componentOptions.tag,
                      {
                        attrs: item.data?.attrs,
                        props: item.componentOptions.propsData,
                        class: item.data?.class || item.data?.staticClass,
                        style: item.data?.style || item.data?.staticStyle,
                        directives: item.data?.directives
                      },
                      item.componentOptions.children
                    )
                  ]
                )
              })
            )
          ]
        )
      ]
    }
    return h(
      'div',
      {
        class: {
          'table-buttons': true
        }
      },
      children
    )
  }
}
</script>

<style lang="scss">
.table-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  .el-dropdown {
    margin-left: 10px;
  }
}
</style>
